const guideGen52 = [
  "Eventuell: Pokéwood & Kampf gegen Riolu",
  "Eventuell: Erster Rivale-Kampf",
  "Eventuell: Erhalt des Starter-Pokémon in Avenitia",
  "Route 19 – Erstes wildes Pokémon",
  "Sancturia – Pokédex-Erhalt von Bell",
  "Route 20 – Kampf gegen Bianca & Cheren",
  "Sognano-Wald – Story & Kämpfe",
  "Eventuell: Fund von Azurill oder Pichu",
  "Eventuell: Kampf mit Team Plasma",
  "Eventuell: Arena 1 (Normal) in Gavina City",
  "Pokéwood – Filme drehen (Pflicht)",
  "Frachtwerft – Kampf gegen Team Plasma",
  "Route 20 – Rückweg & Plasma-Flucht",
  "Route 21 – Richtung Dausing",
  "Eventuell: Dausing – Schiff nach Vapydro City",
  "Vapydro City – Arena 2 (Gift)",
  "Pokémon-Weltturnier (PWT) – Mini-Turnier",
  "Frachtwerft – Plasma-Schiff und Kampf",
  "Route 6 – Richtung Marea City",
  "Marea City – Arena 3 (Käfer)",
  "Kanalisation von Marea – Kampf mit Plasma",
  "Pokémon Center – Story-Fortschritt",
  "Route 6 – Forschungslabor & Story",
  "Felstunnel – Richtung Rayono City",
  "Rayono City – Arena 4 (Elektro)",
  "Kampf-U-Bahn (optional)",
  "Route 5 – Richtung Twindrake City",
  "Route 16 & Lostorn-Wald – Optional",
  "Brücke & Wolkenkratzerstraße",
  "Twindrake City – Arena 5 (Flug)",
  "Höhle der Erkenntnis – Story-Fortschritt",
  "Route 7 – Richtung Septerna City",
  "Septerna City – Arena 6 (Geist)",
  "Turm des Himmels – Event & Story",
  "Route 8 – Richtung Ondula",
  "Moor von Nevaio – Eventuell Pokémon fangen",
  "Ondula – Unterwasser-Kampf & Story",
  "Küste & Plasma-Schiff – Story voranbringen",
  "Route 22 – Rivalen-Kampf & Terrakium",
  "Sieben-Wege-Kreuzung – Richtung Siegesstraße",
  "Route 23 – Elite-Vorbereitung",
  "Pokémon-Liga – Top 4 & Champ (Iris)",
];

export default guideGen52;
